import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@draeger-academy/common';
import { DaLinkModule } from '../da-link';
import { DaButtonModule } from '../da-button';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { TeaserCardBoxComponent } from './teaser-card-box.component';

@NgModule({
    declarations: [TeaserCardBoxComponent],
    exports: [TeaserCardBoxComponent],
    imports: [CommonModule, PipesModule, DaLinkModule, DaButtonModule, DaProgressiveImageModule]
})
export class TeaserCardBoxModule {}
